import { emptySplitApi } from "./emptyApi"

// Types for the API responses
export interface TagDto {
  id: string
  name: string
  color: string
  description?: string
  createdAt: string
  updatedAt: string
}

export interface CreateTagDto {
  name: string
  color: string
  description?: string
}

export interface UpdateTagDto {
  name?: string
  color?: string
  description?: string
}

export const tagsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    // Get all company tags
    getCompanyTags: builder.query<TagDto[], void>({
      query: () => "tags",
      providesTags: result =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Tag" as const, id })),
              { type: "Tag", id: "LIST" },
            ]
          : [{ type: "Tag", id: "LIST" }],
    }),

    // Get tag by ID
    getTagById: builder.query<TagDto, string>({
      query: tagId => `tags/${tagId}`,
      providesTags: (_result, _error, tagId) => [{ type: "Tag", id: tagId }],
    }),

    // Create new tag
    createTag: builder.mutation<TagDto, CreateTagDto>({
      query: data => ({
        url: "tags",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "Tag", id: "LIST" }],
    }),

    // Update tag
    updateTag: builder.mutation<TagDto, { tagId: string; data: UpdateTagDto }>({
      query: ({ tagId, data }) => ({
        url: `tags/${tagId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (_result, _error, { tagId }) => [
        { type: "Tag", id: tagId },
        { type: "Tag", id: "LIST" },
      ],
    }),

    // Delete tag
    deleteTag: builder.mutation<void, string>({
      query: tagId => ({
        url: `tags/${tagId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, tagId) => [
        { type: "Tag", id: tagId },
        { type: "Tag", id: "LIST" },
      ],
    }),
  }),
})

export const {
  useGetCompanyTagsQuery,
  useGetTagByIdQuery,
  useCreateTagMutation,
  useUpdateTagMutation,
  useDeleteTagMutation,
} = tagsApi
